/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { RecordingRestriction } from '../../../core/usecases';
import { Mousetrap, RestrictionMessage } from '../../common';
import { ImageLoader } from '../../ImageLoader';
import { ImageLoaderTypes } from '../../ImageLoader/ImageLoaderTypes';
import { ChannelCellProps } from './ChannelCellProps';

import './ChannelCell.scss';

const ChannelCell: FunctionComponent<ChannelCellProps> = ({
    channel,
    children,
    highlightId,
}): JSX.Element => {
    if (!channel) return <div className="channel-cell"></div>;

    const { channelNumber, callSign, channelLogoUrl, videoResolution, isSubscribed } = channel;

    return (
        <Mousetrap value={highlightId}>
            <div className="channel-cell">
                {children}
                <RestrictionMessage
                    displayType={RecordingRestriction.CHANNEL_CELL}
                    channel={channel}
                />
                <div
                    className={`channel-number ${!isSubscribed ? 'channel-fadeout' : ''} ${
                        channelNumber && channelNumber.length > 4 ? 'adjust-channel-number' : ''
                    }`}
                    data-testid="channel-number"
                >
                    {channelNumber}
                </div>
                <div
                    className={`stream-type-icon ${videoResolution}`}
                    data-testid="stream-type-icon"
                ></div>
                <div data-testid="guide-channel-branding">
                    <ImageLoader
                        src={channelLogoUrl}
                        imageType={ImageLoaderTypes.CHANNEL_BRANDING_IMAGE}
                        placeholder={callSign}
                    />
                </div>
            </div>
        </Mousetrap>
    );
};

export default React.memo(ChannelCell);
